import { useState } from 'react';
import { Flex } from 'antd';
import { useLocation } from 'react-router-dom';
import { MoreOutlined } from '@ant-design/icons';
import { MongoAbility } from '@casl/ability';
import { MDropdown } from '@Components/Base';

import RequiredNotification from '@Components/RequiredNotification/RequiredNotification';

import { extractSiteSection } from '@Components/utils';
import { TableManageRequestsActionsProps } from './types';
import { items } from './ActionItems';

const TableManageRequestsActions: React.FC<
  TableManageRequestsActionsProps & {
    permissions: MongoAbility;
  }
> = ({
  status,
  requestType,
  requestNo,
  permissions,
  onSubmit,
  onEdit,
  onView,
  onCancel,
  onCopy,
  onDelete,
  onApprovalHistory,
}) => {
  const [showDeleteNotification, setShowDeleteNotification] = useState(false);

  const { pathname } = useLocation();
  const siteSection = extractSiteSection(pathname);

  const openDeleteNotification = (): void => setShowDeleteNotification(true);
  const closeDeleteNotification = (): void => setShowDeleteNotification(false);

  const performDelete = (): void => {
    closeDeleteNotification();
    onDelete();
  };

  return (
    <div>
      <Flex style={{ marginLeft: '15px' }}>
        <MDropdown
          menu={{
            items: items({
              status,
              requestType,
              permissions,
              siteSection,
              onEdit,
              onSubmit,
              onView,
              onCancel,
              onCopy,
              onDelete: openDeleteNotification,
              onApprovalHistory,
            }),
          }}
          trigger={['click']}
        >
          <MoreOutlined />
        </MDropdown>
      </Flex>
      <RequiredNotification
        title="Delete Request"
        message={`Are you sure you want to delete request no.${requestNo}?`}
        isModalOpen={showDeleteNotification}
        textSuccessBtn="Yes, Delete"
        textCancelBtn="No, Thanks"
        handleCancel={closeDeleteNotification}
        handleSuccess={performDelete}
        isDeleteNotification
      />
    </div>
  );
};

export default TableManageRequestsActions;
